/**
 * Gets the current deployment version
 * This can be set via environment variable or build-time injection
 */
export const getDeploymentVersion = (): string => {
  // Try to get from environment variable first
  const envVersion = import.meta.env.VITE_APP_VERSION;
  if (envVersion) {
    return envVersion;
  }

  // Fallback to build timestamp if no version is set
  const buildTime = import.meta.env.VITE_BUILD_TIME;
  if (buildTime) {
    return buildTime;
  }

  // Final fallback
  return 'unknown';
};

/**
 * Gets a human-readable deployment identifier
 */
export const getDeploymentIdentifier = (): string => {
  const version = getDeploymentVersion();

  if (version === 'unknown') {
    return 'Development';
  }

  // If it's a timestamp, format it nicely
  if (/^\d{4}-\d{2}-\d{2}/.test(version)) {
    return `Deployed ${version}`;
  }

  return `Version ${version}`;
};

/**
 * Checks if the current deployment is different from the stored one
 */
export const hasDeploymentChanged = (): boolean => {
  const currentVersion = getDeploymentVersion();
  const storedVersion = localStorage.getItem('deploymentVersion');

  return storedVersion !== null && storedVersion !== currentVersion;
};
